import React from 'react';
import classNames from 'classnames';
import './PinProgressMarker.styl';

/** Pin (small box with tail above to point to something)
    to mark progress on the progress bar
 */
export default class PinProgressMarker extends React.PureComponent {
  render() {
    const {
      color,
      percentage,
      children,
      // flip it upside down
      inverted,
    } = this.props;
    return (
      <div
        className={classNames('pin-progress-marker-wrapper', {inverted})}
        style={{left: `${percentage}%`}}>
        <div className="arrow" style={{borderBottom: `5px solid ${color}`}} />
        <div className="pin-progress-marker" style={{backgroundColor: color}}>
          {children}
        </div>
      </div>
    );
  }
}
